<template>
	<div class="full">
		<vxe-table :loading="loading" :data="inventory" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="goodscode" title="商品编码"></vxe-column>
			<vxe-column field="storage_name" title="仓库名称"></vxe-column>
			<vxe-column field="quantity" title="实际库存"></vxe-column>
			<vxe-column field="availableSize" title="可用库存"></vxe-column>
			<vxe-column field="underway" title="在途"></vxe-column>
			<vxe-column field="bottom" title="下限"></vxe-column>
			<vxe-column field="top" title="上限"></vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				inventory: [],
				warehouse:[],
				loading:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if(this.row){
				this.getInventory()
			}else{
				this.inventory = []
			}
		},
		computed: {

		},

		methods: {
			getInventory() {
				this.loading = true
				this.$api.goods.getInventory(this.row.id).then((res) => {
					this.inventory = res['inventory']
					this.warehouse = res['warehouseinfo']
					this.inventory.forEach((item)=>{
						let warehouse = this.warehouse.find((_item)=>{
							return _item['wlnid'] == item['storageID']
						})
						if(warehouse){
							item.bottom = warehouse.bottom
							item.top = warehouse.top
							item.goodscode = warehouse.goodscode
						}
					})
					this.loading = false
				},()=>{
					this.loading = false
				})
			},

		},
		components: {

		}
	}
</script>
